'use client';
import { useEffect, useState } from 'react';
import './Select.css';
import SlSelect from '@shoelace-style/shoelace/dist/react/select/index.js';
import SlIcon from '@shoelace-style/shoelace/dist/react/icon/index.js';
import SlOption from '@shoelace-style/shoelace/dist/react/option/index.js';

interface SelectOption {
	key: string | number;
	name: string;
	value: string;
	children?: SelectOption[];
}

interface SelectProps {
	value: string;
	label?: string;
	onChange: (e: any) => void;
	required?: boolean;
	className?: string;
	clearable?: boolean;
	options: SelectOption[] | undefined;
	[key: string]: any;
}

const Select = ({
	value,
	label,
	onChange,
	required,
	clearable,
	className,
	options,
	...rest
}: SelectProps) => {
	const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 900);

	useEffect(() => {
		const check = () => {
			setIsMobile(window.innerWidth <= 900);
		};
		check();
		window.addEventListener('resize', check);
		return () => window.removeEventListener('resize', check);
	}, []);

	if (isMobile) {
		const s = (
			<select
				className={className != null ? className : ''}
				value={value}
				onChange={onChange}
			>
				{clearable ? <option value={''} /> : <option value={''} disabled hidden />}
				{options?.map((o) => {
					if (o.children != null) {
						return (
							<optgroup label={o.name}>
								{o.children.map((c) => {
									return (
										<option key={c.key} value={String(c.value)}>
											{c.name}
										</option>
									);
								})}
							</optgroup>
						);
					} else {
						return (
							<option key={o.key} value={o.value}>
								{o.name}
							</option>
						);
					}
				})}
			</select>
		);

		if (label != null) {
			return (
				<label>
					<div className='select__label'>
						{label}
						{required && <div className='select__label-asterisk'>*</div>}
					</div>
					{s}
				</label>
			);
		}

		return s;
	}

	return (
		<SlSelect
			className={className}
			value={value}
			label={label}
			onSlChange={onChange}
			required={required}
			clearable={clearable}
			{...rest}
		>
			{options?.map((o) => {
				if (o.children != null) {
					return (
						<>
							<small>{o.name}</small>
							{o.children.map((c) => {
								return (
									<SlOption key={c.key} value={String(c.value)}>
										{c.name}
									</SlOption>
								);
							})}
						</>
					);
				} else {
					return (
						<SlOption key={o.key} value={o.value}>
							{o.name}
						</SlOption>
					);
				}
			})}
			<SlIcon name='x-circle' slot='clear-icon' />
		</SlSelect>
	);
};

export { Select };
export type { SelectOption };
